import classNames from 'classnames';
import { CSSProperties, Fragment } from 'react';
import { SharedSliderProps } from './sharedSliderHelpers';
import styles from './styles/styles.module.scss';

type SliderPointsProps = {
  getIsFilled: (index: number) => boolean;
} & Pick<SharedSliderProps<any>, 'marks'>;

const SliderPoints = ({ getIsFilled, marks }: SliderPointsProps) => {
  const maxIndex = marks.length - 1;
  const getPointLeft = (index: number) => `${(100 * index) / maxIndex}%`;

  const points = marks.map((mark, index) => {
    if (mark.label === undefined) {
      return null;
    }
    let className = '';
    let style: CSSProperties | undefined = undefined;
    if (index === 0) {
      className = styles.firstPoint;
    } else if (index === maxIndex) {
      className = styles.lastPoint;
    } else {
      style = { left: getPointLeft(index) };
    }

    return (
      <Fragment key={`slider-point-dot-${index}`}>
        <div className={classNames(styles.pointDot, { [styles.filled]: getIsFilled(index) }, className)} style={style} />
        <div className={classNames(styles.pointLabel, className)} style={style}>
          {mark.label}
        </div>
      </Fragment>
    );
  });

  return points;
};

export default SliderPoints;
